import header from "@/layout/header.vue";
import Workplace from "@/views/workplace.vue";
import history from "@/views/workplace/history.vue";
export const workplace = {
  path: "/workplace",
  components: {
    default: Workplace,
    header,
  },
  meta: {
    menu: true,
    header: false,
  },
  redirect: "/workplace/history",
  children: [
    {
      path: "/",
      name: "workplace",
      component: () => import("@/views/workplace.vue"),
    },
    {
      path: "history",
      name: "history",
      component: history,
    },
    {
      path: "exibition",
      name: "exibition",
      component: () => import("@/views/workplace/exibition/exibition.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: "exibitionList",
      name: "exibitionList",
      component: () => import("@/views/workplace/exibition/exibitionList.vue"),
      meta: {
        menu: false,
        header: true,
        title: "选择模板",
        back: true,
        keepAlive: true,
      },
    },
    {
      path: "echarts",
      name: "echarts",
      component: () => import("@/views/workplace/echarts.vue"),
      meta: {
        menu: false,
        header: true,
        back: true,
      },
    },
    {
      path: "exibitionDetails/:id",
      name: "exibitionDetails",
      component: () =>
        import("@/views/workplace/exibition/exibitionDetails.vue"),
      meta: {
        menu: false,
        header: true,
        title: "基本信息",
        requiresAuth: false,
        back: {
          url: "/workplace/exibition",
        },
      },
    },
    {
      path: "exbitionDetails",
      name: "exbitionDetails",
      component: () =>
        import("@/views/workplace/exibition/exibitionDetails.vue"),
      meta: {
        menu: false,
        header: true,
        requiresAuth: false,
        title: "基本信息",
        back: true,
      },
    },
    {
      path: "digitalConfig",
      name: "digitalConfig",
      component: () => import("@/views/digital/digitalHumanConfig.vue"),
      meta: {
        menu: true,
        header: true,
        requiresAuth: false,
        title: "数字人配置",
        back: false,
      },
    },
    {
      path: "personnelConfig",
      name: "personnelConfig",
      component: () => import("@/views/digital/personnelConfig.vue"),
      meta: {
        menu: true,
        header: true,
        requiresAuth: false,
        title: "人设配置",
        back: false,
      },
    },
    {
      path: "knowledgeBaseConfig",
      name: "knowledgeBaseConfig",
      component: () => import("@/views/digital/knowledgeBaseConfig.vue"),
      meta: {
        menu: true,
        header: true,
        requiresAuth: false,
        title: "知识库配置",
        back: false,
      },
    },
    {
      path: "config",
      name: "config",
      component: () => import("@/views/digital/config.vue"),
      meta: {
        menu: true,
        header: true,
        requiresAuth: true,
        title: "新建数字人",
        back: true,
      },
    },
    {
      path: "marketingdata",
      name: "marketingdata",
      component: () => import("@/views/workplace/marketing/marketingdata.vue"),
      meta: {
        menu: true,
        header: true,
        requiresAuth: false,
        title: "营销数据",
        back: false,
      },
    },

    {
      path: "hall",
      name: "hall",
      // component: { template: "<router-view></router-view>" },
      children: [
        {
          path: "hallList",
          name: "hallList",
          component: () => import("@/views/workplace/hall/list.vue"),
          meta: {
            menu: true,
            header: true,
            title: "",
          },
        },
        {
          path: "createHall",
          name: "createHall",
          component: () => import("@/views/workplace/hall/create.vue"),
          meta: {
            menu: false,
            header: true,
            title: "",
            back: true,
          },
        },
        {
          path: "compileHall",
          name: "compileHall",
          component: () => import("@/views/workplace/hall/compileHall.vue"),
          meta: {
            menu: false,
            header: true,
            back: {
              url: "/workplace/hall/hallList",
            },
          },
        },
        {
          path: "bindExbition/:id",
          name: "bindExbition",
          component: () => import("@/views/workplace/hall/bindExbition.vue"),
          meta: {
            menu: false,
            header: true,
            back: {
              url: "/workplace/hall/hallList",
            },
          },
        },
        {
          path: "hallDetails/:id",
          name: "hallDetails",
          alias: "/h/:id",
          component: () => import("@/views/workplace/hall/hallDetails.vue"),
          meta: {
            menu: false,
            header: true,
            back: {
              url: "/workplace/hall/hallList",
            },
          },
        },
      ],
    },

    {
      path: "teamwork",
      name: "teamwork",
      component: () => import("@/views/workplace/teamwork.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: "designer",
      components: {
        default: () => import("@/views/designer/index.vue"),
      },
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "coupon",
      name: "coupon",
      component: () => import("@/views/workplace/coupon/index.vue"),
      meta: {
        menu: true,
        header: true,
        back: false,
      },
    },
    {
      path: "moreCoupon",
      name: "moreCoupon",
      component: () => import("@/views/workplace/coupon/moreCoupon.vue"),
      meta: {
        menu: true,
        header: true,
        back: true,
      },
    },
    {
      path: "resource",
      name: "resource",
      component: () => import("@/views/workplace/resource/index.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: "order",
      name: "order",
      component: () => import("@/views/order/index.vue"),
      meta: {
        menu: true,
        header: false,
      },
    },
    {
      path: ":pathMatch(.*)*",
      name: "404",
      components: {
        default: () => import("@/views/404.vue"),
      },
      meta: {
        menu: true,
        title: "暂未开放",
      },
    },
  ],
};
